import spotEdit from "./edit.vue";
import spotList from './list.vue'
let a = Object.assign({spotEdit, spotList} )
export default a;
